"use client";

import Link from "next/link";
import { BlurImage } from "../images/blur-image";
import { useAppContext } from "~/contexts/AppContext";

export const Footer = () => {
  const { showWhiteLabelFooterLogo } = useAppContext();

  return (
    <div className="relative flex w-full flex-col-reverse gap-2 bg-primary p-6 text-sm text-white md:flex-row md:items-center md:justify-between md:p-8">
      <div>Copyright {new Date().getFullYear()}</div>
      {showWhiteLabelFooterLogo && (
        <div className="absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 transform gap-1 md:flex items-center justify-center">
          <span className="text-[10px] md:text-[12px]">Powered by</span>
          <BlurImage
            alt="golf district logo"
            src={`https://${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_URL}/desktopfooterlogo.svg`}
            width={157}
            height={39}
          />
        </div>
      )}
      <div className="flex flex-col items-start gap-2 md:items-end lg:flex-row lg:items-center">
        <Link href={`/faq`} data-testid="footer-help-id" prefetch={false}>
          Help
        </Link>
        <Link href={`/how-to-guide`} data-testid="footer-how-to-guide-id" prefetch={false}>
          How to Guide
        </Link>
        {/* <Link href={`/about-us`} data-testid="footer-about-us-id">
          About Us
        </Link> */}
        <Link href={`/privacy-policy`} data-testid="footer-privacy-policy-id" prefetch={false}>
          Privacy Policy
        </Link>
        <Link
          href={`/terms-of-service`} prefetch={false}
          data-testid="footer-terms-of-service-id"
        >
          Terms of Service
        </Link>
      </div>
      {showWhiteLabelFooterLogo && (
        <div className="flex items-center justify-center gap-1 md:hidden">
          <span className="text-[10px] md:text-[12px]">Powered by</span>
          <BlurImage
            alt="golf district logo"
            src={`https://${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_URL}/mobilefooterlogo.svg`}
            width={157}
            height={39}
          />
        </div>
      )}
    </div>
  );
};
